import { render, staticRenderFns } from "./GroupUserTable.vue?vue&type=template&id=67d5ed71&scoped=true"
import script from "./GroupUserTable.vue?vue&type=script&lang=js"
export * from "./GroupUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5ed71",
  null
  
)

export default component.exports